<template>
  <div class="cycles-page min-w-0">
    <Head :title="__('Capture cycles')" />
    <Heading class="mb-4 md:mb-6">{{ __('Capture cycles') }}</Heading>
    <CyclesApp
      :exchange="exchange"
      :api-base="apiBase"
    />
  </div>
</template>

<script setup>
import CyclesApp from '../components/CyclesApp.vue'

defineProps({
  exchange: {
    type: String,
    default: 'Binance',
  },
  apiBase: {
    type: String,
    required: true,
  },
})
</script>
